import React from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import IconInfoCircle from "assets/icons/consultation-detail-icon.svg";
import IconArrowDown from "assets/icons/expandAllIcon.svg";

function AccordianConsultationDetail(data) {
  return (
    <>
      <Card className="consultation-detail card-accordian">
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="4">
            <div className="header-title">
              <img
                src={IconInfoCircle}
                alt="icon-info-circle"
                className="title-icon"
              />
              <div className="title">Consultation Details</div>
            </div>
            <div>
              <img src={IconArrowDown} alt="icon-arrow-down" />
            </div>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="4">
          <Card.Body>
            <div className="info-row">
              <div className="label text-uppercase">Summary</div>
              <blockquote className="info">
                {data.chat.description || "N/A"}
              </blockquote>
            </div>
            <div className="info-row">
              <div className="label text-uppercase">Additional Info</div>
              <div className="sub-title">Are you taking any medications?</div>
              <blockquote className="info">
                {data.chat.medication_note || "N/A"}
              </blockquote>
              <div className="sub-title">
                Do you have any previously diagnosed condition?
              </div>
              <blockquote className="info">
                {data.chat.previous_diagnose_note || "N/A"}
              </blockquote>
              <div className="sub-title">Do you have any allergies?</div>
              <blockquote className="info">
                {data.chat.allergy_note || "N/A"}
              </blockquote>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}

export default AccordianConsultationDetail;
